import { k } from "@/utilities/i18n";
import translate from "@/utilities/i18n/getTranslate";
export var partnerSubscriptionSteps = function (currency) { return [
    {
        title: translate(k.FN_pickPlan),
        description: translate(k.FN_accessToPlatform),
    },
    {
        title: translate(k.FN_selectMessageCurrency),
        description: translate(k.FN_weBillInEur, {
            currency: (currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) || "EUR",
        }),
    },
    {
        title: translate(k.WIZ_billingAddress),
        description: translate(k.WIZ_billingAddressDescription),
    },
    {
        title: translate(k.WIZ_paymentMethod),
        description: translate(k.FN_chargePaymentPlan),
    },
]; };
export var clientPaidSubscriptionSteps = function (currency) { return [
    {
        title: translate(k.FN_selectMessageCurrency),
        description: translate(k.FN_weBillInEur, {
            currency: (currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) || "EUR",
        }),
    },
    {
        title: translate(k.WIZ_billingAddress),
        description: translate(k.WIZ_billingAddressDescription),
    },
    {
        title: translate(k.WIZ_paymentMethod),
        description: translate(k.FN_chargePaymentPlan),
    },
]; };
export var savedPartnerSubscriptionSteps = [
    {
        title: translate(k.FN_selectPaymentPlan),
        description: translate(k.FN_accessToPlatform),
    },
    {
        title: translate(k.WIZ_billingAddress),
        description: translate(k.WIZ_billingAddressDescription),
    },
    {
        title: translate(k.WIZ_paymentMethod),
        description: translate(k.FN_chargePaymentPlan),
    },
];
//# sourceMappingURL=data:application/json;base64,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